import { Component, Input } from '@angular/core';
import { MessageToolkitBanner } from './data-models/mkt-banner.interface';

@Component({
  selector: 'idp-mkt-banner',
  templateUrl: './mkt-banner.component.html',
  styleUrls: ['./mkt-banner.component.scss']
})
export class MktBannerComponent {
  @Input() config: MessageToolkitBanner = {} as MessageToolkitBanner;
  @Input() colorTheme = '';

  /** Generates the classes that will be used by the component */
  getClasses(): string {
    let contentClassName = 'mkt-banner-wrapper';
    switch (this.config.templateType) {
      case 'splitbanner':
        contentClassName = 'idp__banner--split  flex-row-reverse';
        break;
      case 'slimbanner':
        contentClassName = this.getSplitWrapper();
        break;
      case 'alertbanner':
        contentClassName = 'styleWithoutTopBorder';
        break;
    }
    return contentClassName;
  }

  getImageWrapperClasses() {
    let setSplitBannerClass = 'banner-col-1';
    switch (this.config.templateType) {
      case 'splitbanner':
        setSplitBannerClass = 'col-7 banner-d-sm-none';
        break;
      case 'slimbanner':
        setSplitBannerClass = this.getSplitBannerClass();
        break;
      case 'alertbanner':
        setSplitBannerClass = 'idp__slimbanner--imageplaceholder banner-col-1 ';
        break;
    }
    return setSplitBannerClass;
  }

  getSplitBannerClass() {
    return this.colorTheme
      ? `mkt-banner-wrapper--${this.colorTheme} idp__slimbanner--imageplaceholder banner-col-1 `
      : 'mkt-banner-wrapper ';
  }

  getSplitWrapper() {
    return this.colorTheme
      ? `mkt-banner-wrapper--${this.colorTheme}`
      : 'mkt-banner-wrapper';
  }

  getIconClasses(): string {
    let setSplitBannerClass = 'idp__slimBanner--image-desktop';
    switch (this.config.templateType) {
      case 'splitbanner':
        setSplitBannerClass = 'idp__slimBanner--image-desktop split-image';
        break;
    }
    return setSplitBannerClass;
  }

  getBannerLabelClasses(): string {
    return this.colorTheme ? 'mkt-banner-label' : 'labelHeading';
  }

  getBannerMessageClasses(): string {
    return this.colorTheme
      ? `mkt-banner-intro--${this.colorTheme}`
      : 'mkt-banner-intro';
  }

  getBannerContentClasses(): string {
    let contentBannerClass = 'col-10';
    switch (this.config.templateType) {
      case 'splitbanner':
        contentBannerClass = 'idp__banner--split-content banner-col';
        break;
      case 'slimbanner':
        contentBannerClass = this.getSlimBannerClass();
        break;
      case 'alertbanner':
        contentBannerClass = 'col-10';
        break;
    }
    return contentBannerClass;
  }

  getSlimBannerClass() {
    return this.colorTheme
      ? `mkt-banner-wrapper--${this.colorTheme} col-10`
      : 'mkt-banner-wrapper col-10';
  }

  getBorderColor() {
    const styleObj = {
      border: ''
    };
    if (this.config.templateType === 'alertbanner') {
      styleObj.border = '';
    } else {
      styleObj.border = `1px solid ${this.config.alertbannerbdrcolor}`;
    }
    return styleObj;
  }

  getBgColor() {
    const styleObj = {
      background: this.config.alertbannerbgcolor
    };
    return styleObj;
  }

  getDescriptionColor() {
    const textColor = {
      color: this.config.descriptionColor
    };
    return textColor;
  }
}
